import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CampaignService {

  dashboard: any;
  popupData: any;
  api: string = environment.apiEndPoint;

  constructor(private http: HttpClient) { }

  campaignList(PageIdex: any, data: any) {
    return this.http.get(this.api+'/Campaign/GetAll?'+'PageIdex='+PageIdex, {params: data});
  }

  filterCampaignList(pageIdex: number, data: any) {
    return this.http.get(this.api+'//FilterCampaign/GetAll?PageIdex='+pageIdex, {params: data});
  }

  getCampaignScreenData() {
    return this.http.get(this.api+ '/Campaign/GetSD');
  }

  getCampaignSearchData() {
    return this.http.get(this.api+ '/Campaign/GetSearchSD');
  }

  saveCampaign(data: any) {
    return this.http.post(this.api+'/Campaign',data);
  }

  saveFilterCampaign(data: any) {
    return this.http.post(this.api + '/FilterCampaign', data);
  }

  updateCampaign(data: any) {
    return this.http.put(this.api+'/Campaign',data);
  }

  updateFilterCampaign(payLoad: any) {
    return this.http.put(this.api + '/FilterCampaign', payLoad);
  }

  deleteCampaign(id: any) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        campaignId: id
      },
    };
    return this.http.delete(this.api+'/Campaign',options);
  }

  deleteFilterCampaign(id: number) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: {
        filterCampaignId: id
      }
    };
    return this.http.delete(this.api + '/FilterCampaign', options);
  }

  uploadCSVfile(data: any) {
    return this.http.post(this.api+ '/CampaignPhoneData', data);
  }

  getCampaign(id: any) {
    return this.http.get(this.api+'/Campaign?CampaignId='+ id);
  }

  getFilterCampaign(id: number) {
    return this.http.get(this.api + '/FilterCampaign?FilterCampaignId=' + id);
  }

  getCampaignPhoneData(PageIdex: any,RowCount: any, CampaignId: any) {
    return this.http.get(this.api+'/CampaignPhoneData?PageIdex='+PageIdex+ '&RowCount='+RowCount+'&CampaignId='+ CampaignId);
  }

  getInstantCampaignPhoneData(PageIdex: any,RowCount: any, CampaignId: any) {
    return this.http.get(this.api+'/CampaignPhoneData/GetInstantCampaignPhoneData?PageIdex='+PageIdex+ '&RowCount='+RowCount+'&CampaignId='+ CampaignId);
  }

  generateCampaignPin(campaignId: any) {
    return this.http.put(this.api+'/Campaign/GeneratePin',campaignId)
  }

  deletePhoneData(id: any) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        ...id
      },
    };
    return this.http.delete(this.api+'/CampaignPhoneData',options);
  }

  verifyCampaignPin(data: any) {
    return this.http.put(this.api+'/Campaign/VerifyPin',data);
  }

  getCampaignEstimates(payload: any) {
    const body = typeof payload === 'number' || typeof payload === 'string'
      ? { campaignId: payload }
      : payload;

    return this.http.put(this.api + '/Campaign/UpdateEstimates', body);
  }

  setCampaignStatus(data: any) {
    return this.http.put(this.api+'/Campaign/SetStatus',data);
  }

  testSMSCount() {
    return this.http.get(this.api+'/TestSMS');
  }

  dashboardInfo() {
    return this.http.get(this.api + '/Dashboard');
  }

  copyCampaign(id: any) {
    return this.http.post(this.api + '/Campaign/Copy', {campaignId: id});
  }

  copyFilterCampaign(id: number) {
    return this.http.post(this.api + '/FilterCampaign/Copy', {filterCampaignId: id});
  }

  testSMS(method:'get'|'post') {
    return method=='get'? this.http.get(this.api+'/TestSMS'):this.http.post(this.api+'/TestSMS',{});
  }

  checkBalance(campaignId: any) {
    return this.http.post(this.api+'/Campaign/CheckBalance',{campaignId});
  }

  getCampaignExecDetail(campaignId: any, PageIdex: any) {
    return this.http.get(this.api+'/CampaignExecDetail?CampaignId='+campaignId+'&PageIdex='+PageIdex);
  }

  getCampaignExecDetailCsv(campaignId: any) {
    return this.http.get(this.api+'/CampaignExecDetail/GetCSV?CampaignId='+campaignId, {
      responseType: 'blob'
    });
  }

  uploadContactsList(phoneList: any, campaignId: any){
    return this.http.post(this.api + '/CampaignPhoneData/UploadList', {phoneList: phoneList, campaignId: campaignId});
  }

  uploadInstantContactsList(phoneList: any, campaignId: any){
    return this.http.post(this.api + '/CampaignPhoneData/UploadInstantList', {phoneList: phoneList, campaignId: campaignId});
  }
}
